import React, { useState, useRef } from 'react';
import { Flex, Heading, Button, Box, FormControl, FormLabel } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import CustomInput from '../../../../components/common/Input/input';
import * as api from '../../../../api/tipoMidia';
import Swal from 'sweetalert2';

function InserirTipoMidia() {
  const navigate = useNavigate();
  const refInput = useRef<HTMLInputElement>(null);

  const [valoresForm, setValoresForm] = useState({
    dscMidia: { value: '', error: false },
    codMidia: { value: '' }
  });

  const [ordemValida, setOrdemValida] = useState(true);
  const [ordemRecomendada, setOrdemRecomendada] = useState<number | null>(null);

  const formularioValido = () => {
    return valoresForm.dscMidia.value.trim().length >= 3;
  };

  const alterarCampo = (campo: string, valor: string) => {
    setValoresForm({ ...valoresForm, [campo]: { error: false, value: valor } });
  };

  const validarOrdemAoSair = async (numeroOrdem: string, refInput: React.RefObject<HTMLInputElement>) => {
    try {
      const ordensExistentes = await api.validarIdsDisponiveis(Number(numeroOrdem));
      if (!ordensExistentes || (Array.isArray(ordensExistentes) && ordensExistentes.length === 0)) {
        setOrdemValida(true);
        setOrdemRecomendada(null);
      } else {
        setOrdemValida(false);
        const recomendada = calcularOrdemRecomendada(ordensExistentes);
        Swal.fire({
          icon: 'warning',
          title: 'Código Indisponível',
          text: `A código fornecido não está disponível. É recomendado usar o número ${recomendada}`,
          confirmButtonText: 'OK',
          confirmButtonColor: '#1789FC',
          willClose: () => {
            alterarCampo('codMidia', '');
            if (refInput.current) {
              refInput.current.value = '';
            }
            setOrdemRecomendada(recomendada);
          }
        });
      }
    } catch (erro) {
      setOrdemValida(false);
      setOrdemRecomendada(null);
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Houve um erro ao validar a ordem. Tente novamente mais tarde.',
        confirmButtonText: 'Fechar',
        confirmButtonColor: '#1789FC',
      });
    }
  };

  const calcularOrdemRecomendada = (ordensExistentes: any[]) => {
    const todasOrdens = ordensExistentes.map(item => Number(item.codMidia));
    let recomendada = 1;
    while (todasOrdens.includes(recomendada)) {
      recomendada++;
    }
    return recomendada;
  };

  const enviarFormulario = async () => {
    const { dscMidia, codMidia } = valoresForm;
    const parametros = {
      dscMidia: dscMidia.value || null,
      codMidia: Number(codMidia.value) || null
    };
    try {
      const resposta = await api.inserirTipoMidia(parametros);
      const idInserido = resposta.id || resposta.seqTipoMidia || '';
      setValoresForm(prev => ({ ...prev, codMidia: { value: idInserido, error: false } }));
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Tipo de mídia inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK'
      }).then(() => {
        navigate('/cms/configuracao/gerenciar-tipo-midia');
      });
    } catch (erro) {
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao inserir tipo de mídia. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK'
      }).then(() => {
        navigate('/cms/configuracao/gerenciar-tipo-midia');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" mb="20px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Inserir Tipo de Mídia
      </Heading>
      <div className="row mb-3">
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Código</FormLabel>
            <CustomInput
              placeholder="Digite um código"
              value={valoresForm.codMidia.value}
              ref={refInput}
              onChange={(e) => {
                const valor = e.target.value;
                if (valor === '') {
                  alterarCampo('codMidia', '');
                } else if (/^\d+$/.test(valor)) {
                  alterarCampo('codMidia', valor);
                }
              }}
              onBlur={(e) => validarOrdemAoSair(e.target.value, refInput)}
              maxLength={60}
            />
          </FormControl>
        </div>
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Descrição</FormLabel>
            <CustomInput
              placeholder="Digite uma descrição"
              value={valoresForm.dscMidia.value}
              onChange={(e) => alterarCampo('dscMidia', e.target.value)}
              maxLength={20}
            />
          </FormControl>
        </div>
      </div>
      <Box alignItems="flex-end">
        <Button type="button" m="px" onClick={() => navigate(-1)}>
          Desistir
        </Button>
        <Button
          type="button"
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={enviarFormulario}
          isDisabled={!formularioValido()}
        >
          Inserir Tipo de Mídia
        </Button>
      </Box>
    </Flex>
  );
}

export default InserirTipoMidia;
